import React from "react";
import theme from "theme";
import { Theme, Strong, Text, Box, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"faq"} />
		<Helmet>
			<title>
				FitPro Gym Franchise
			</title>
			<meta name={"description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:title"} content={"FitPro Gym Franchise"} />
			<meta property={"og:description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileColor"} content={"#232323"} />
		</Helmet>
		<Components.Header />
		<Section padding="100px 0 100px 0" background="--color-darkL2" quarkly-title="FAQ-4">
			<Text margin="0px 0px 3rem 0px" font="normal 600 42px/1.2 --fontFamily-sans" color="--light">
				<Strong>
					Frequently Asked Questions
				</Strong>
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(2, 1fr)"
				grid-gap="50px 50px"
				md-grid-template-columns="1fr"
				sm-grid-gap="35px 0"
			>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						How much space do I need for a FitPro Gym?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Our gyms typically require 4,000 to 6,000 square feet, but this can vary depending on your location and target market.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						What ongoing fees are involved?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						In addition to the initial investment, franchisees pay a monthly royalty fee of 6% and a marketing contribution of 2%.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						Can I own multiple locations?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Absolutely! Many of our franchisees operate multiple FitPro Gym locations, leveraging economies of scale and maximizing their revenue potential.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						What support does FitPro Gym offer to new franchise owners?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						FitPro Gym provides comprehensive support to franchisees, including initial training, marketing assistance, operational guidance, and ongoing business coaching. Our team is dedicated to helping you succeed with continuous resources and advice to ensure your gym operates smoothly.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						Can I open a FitPro Gym franchise in any location?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						While FitPro Gym offers flexibility in location, we have specific guidelines for territory selection to ensure brand consistency and market potential. We will work with you to identify the best location for your gym, taking into account factors like population, competition, and local demand for fitness services.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						What kind of financial performance can I expect from a FitPro Gym franchise?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Financial performance varies depending on location, market conditions, and management. We provide potential franchisees with detailed financial disclosures and guidance to help you understand the financial aspects of running a FitPro Gym. Our team will support you in creating a business plan tailored to your specific situation.
					</Text>
				</Box>
			</Box>
		</Section>
		<Components.HowTo />
		<Components.Fi />
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});